import { Component, OnInit, ViewChild } from '@angular/core';
import { NumeratorComponent } from '../../../numerator/numerator.component';
import { Project, ProjectType, ProjectWatcher } from '../../projects.model';
import { NumeratorType } from '../../../numerator/numerator.model';
import { NgForm } from '@angular/forms';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { ProjectsRest } from '../../projects.rest';
import { DateInputModel } from '../../../core/shared/date-input/date-input.model';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { ModalComponent } from '../../../core/shared/modal/modal.component';
import { CustomerRow } from '../../../company/customers/customers.model';
import { SelectionMode, GridSelection } from '../../../core/shared/grid/grid.model';
import { CustomersListComponent } from '../../../company/customers/customers-list/customers-list.component';
import { CustomersRest } from '../../../company/customers/customers.rest';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { Router, ActivatedRoute } from '@angular/router';
import { EmployeesListComponent } from '../../../company/employees/employee-list/employees-list.component';
import { Employee } from '../../../company/employees/employee.model';
import { INgxSelectOption } from "ngx-select-ex";
import { DialogService } from '../../../core/shared/dialog/dialog.service';
import { DialogConfig } from '../../../core/shared/dialog/dialog-config';

@Component({
  selector: 'app-projectdetails-header',
  templateUrl: './project-header.component.html',
  styleUrls: ['./project-header.component.scss']
})
export class ProjectDetailsHeaderComponent extends GridSelection implements OnInit, HasPermissions {
  permissions: Permissions;
  private maxValue = 9999999999999;
  private startDate: DateInputModel;
  private endDate: DateInputModel;
  private showDateClearButton: boolean;
  private enabled: boolean;
  public project: Project;

  private states: ObjectToSelect[];
  private employees: ObjectToSelect[];
  private systemVersions: ObjectToSelect[];

  private oldCustomer: string;
  private oldReceiver: string;

  private projectWatchersPath: string;
  private projectWatchersHeaders: any = [
    { displayName: 'Pracownik', propertyName: 'projectWatcherName', propertyType: 'string' }
  ]

  private historyLogsPath: string;
  private historyLogsHeaders: any = [
    { displayName: 'Obiekt', propertyName: 'objectName', propertyType: 'string' },
    { displayName: 'Poprzednia wartość', propertyName: 'oldValue', propertyType: 'string' },
    { displayName: 'Nowa wartość', propertyName: 'newValue', propertyType: 'string' },
    { displayName: 'Data', propertyName: 'updatedDate', propertyType: 'date' },
    { displayName: 'Zmodyfikował', propertyName: 'updatedBy', propertyType: 'string' }
  ]

  @ViewChild(NumeratorComponent) numeratorComponent: NumeratorComponent;
  @ViewChild(ModalComponent) private modal: ModalComponent;
  @ViewChild(GridComponent) projectWatchersGrid: GridComponent;
  @ViewChild('projectForm') projectForm: NgForm;

  constructor(private projectRest: ProjectsRest,
    private permissionService: PermissionsService,
    public dialog: DialogService,
    private customerRest: CustomersRest,
    private router: Router,
    private route: ActivatedRoute) {
    super();
    this.selectionMode = SelectionMode.none;
    this._grid = this.projectWatchersGrid;
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  ngOnInit() {
    this.projectRest.getStates().subscribe((data: ObjectToSelect[]) => {
      this.states = data;
    });

    this.projectRest.getEmployees().subscribe((data: ObjectToSelect[]) => {
      this.employees = data;
    });

    this.projectRest.getSystemVersions().subscribe((data: ObjectToSelect[]) => {
      this.systemVersions = data;
    });
  }

  public setModel(projectDetailsModel: Project, type: ProjectType) {
    this.setPermissions('Project');
    this.project = projectDetailsModel;
    let numeratorType = NumeratorType.project;
    if (parseInt(type.toString()) === ProjectType.Order)
      numeratorType = NumeratorType.order;
    else if (parseInt(type.toString()) === ProjectType.Consultations)
      numeratorType = NumeratorType.consultations;
    else if (parseInt(type.toString()) === ProjectType.Service)
      numeratorType = NumeratorType.service;
    this.numeratorComponent.setModel(this.project, numeratorType, 'Project');
    this.enabled = this.project.isNew
      ? this.permissions.canAdd
      : this.permissions.canEdit;
    this.initializeDates();
    this.historyLogsPath = `api/projects/gethistorylogs/${this.project.id}`;
  }

  private initializeDates() {
    this.startDate = new DateInputModel();
    this.startDate.isReadOnly = !this.enabled;
    this.startDate.isRequired = true;
    this.startDate.name = 'Od:';
    this.startDate.value = new Date(this.project.startDate);
    this.startDate.valueStr = this.startDate.value.toDateString();
    this.startDate.withTime = false;

    this.endDate = new DateInputModel();
    this.endDate.isReadOnly = true;
    this.endDate.isRequired = false;
    this.endDate.name = 'Do:';

    if (this.project.endDate) {

      this.endDate.value = new Date(this.project.endDate);
      this.endDate.valueStr = this.endDate.value.toDateString();
      this.endDate.withTime = false;
      this.endDate.isReadOnly = !this.enabled;
    }
    this.showDateClearButton = this.endDate.isReadOnly !== true;
  }

  public onIsUnlimitedDateChanged() {
    if (this.project.isDateUnlimited) {
      this.endDate = new DateInputModel();
      this.endDate.isReadOnly = true;
      this.project.endDate = null;
    }
    else {
      this.endDate = new DateInputModel();
      this.endDate.value = new Date();
      this.endDate.valueStr = this.endDate.value.toDateString();
      this.project.endDate = this.endDate.value;
      this.endDate.isReadOnly = false;
    }
  }

  public onStartDateChange(element, isValid: boolean) {
    if (!element || !isValid) {
      return;
    }

    this.project.startDate = this.startDate.value;
    this.startDate.valueStr = this.startDate.value.toDateString();
    if (this.project.endDate !== null && this.startDate.value > this.endDate.value) {
      this.project.endDate = this.project.startDate;
      this.endDate.value = this.startDate.value;
      this.endDate.valueStr = this.startDate.valueStr;
    }
  }

  public onEndDateChange(element, isValid: boolean) {
    if (!element || !isValid) {
      return;
    }

    this.project.endDate = this.endDate.value;
    this.endDate.valueStr = this.endDate.value.toDateString();
    if (this.startDate.value > this.endDate.value) {
      this.project.startDate = this.project.endDate;
      this.startDate.value = this.endDate.value;
      this.startDate.valueStr = this.endDate.valueStr;
    }
  }

  public openCustomerModal(customerName: string) {
    let dialogConf = new DialogConfig();
    dialogConf.selectionMode = SelectionMode.single;
    dialogConf.title = 'Wybierz kontrahenta';
    dialogConf.maxwidth = '1200px';
    dialogConf.data = { selectList: true };
    if (customerName != null) {
      dialogConf.data.initialFilters = { code: customerName };
    }

    const ref = this.dialog.open(CustomersListComponent, dialogConf);

    ref.afterClosed.subscribe((result: CustomerRow) => {
      if (result != null) {
        this.project.customerId = result.id;
        this.project.customerName = result.name;
        this.project.receiverId = result.id;
        this.project.receiverName = result.name;
      }
    });
  }

  public openReceiverModal(receiverName: string) {
    let dialogConf = new DialogConfig();
    dialogConf.selectionMode = SelectionMode.single;
    dialogConf.title = 'Wybierz płatnika';
    dialogConf.maxwidth = '1200px';
    dialogConf.data = { selectList: true };
    if (receiverName) {
      dialogConf.data.initialFilters = { code: receiverName };
    }
    const ref = this.dialog.open(CustomersListComponent, dialogConf);
    ref.afterClosed.subscribe((result: CustomerRow) => {
      if (result != null) {
        this.project.receiverId = result.id;
        this.project.receiverName = result.name;
      }
    });
  }

  onKeyDownCustomer() {
    this.oldCustomer = this.project.customerName;
  }

  public onKeyCustomer(event: any) {
    if (this.oldCustomer !== this.project.customerName) {
      this.project.customerId = null;
      this.project.receiverId = null;
    }
    if (event.key === 'Enter') {
      this.searchCustomer();
    }
  }

  onKeyDownReceiver() {
    this.oldReceiver = this.project.receiverName;
  }

  public onKeyReceiver(event: any) {
    if (this.oldReceiver !== this.project.receiverName) {
      this.project.receiverId = null;
    }
    if (event.key === 'Enter') {
      this.searchReceiver();
    }
  }

  private searchCustomer() {
    if (!this.project.customerName)
      return;
    this.customerRest.getCustomerRowsByName(this.project.customerName).subscribe((result: CustomerRow[]) => {
      if (result.length == 1) {
        let customer = result[0];
        this.project.customerId = customer.id;
        this.project.customerName = customer.name;
        this.project.receiverId = customer.id;
        this.project.receiverName = customer.name;
      }
      else {
        this.openCustomerModal(this.project.customerName);
      }
    });
  }

  private searchReceiver() {
    if (!this.project.receiverName)
      return;
    this.customerRest.getCustomerRowsByName(this.project.receiverName).subscribe((result: CustomerRow[]) => {
      if (result.length == 1) {
        let customer = result[0];
        this.project.receiverId = customer.id;
        this.project.receiverName = customer.name;
      }
      else {
        this.openReceiverModal(this.project.receiverName);
      }
    });
  }

  private addProjectWatcher() {
    let dialogConf = new DialogConfig();
    dialogConf.selectionMode = SelectionMode.multi;
    dialogConf.title = 'Wybierz obserwatora';
    dialogConf.maxwidth = '1200px';

    const ref = this.dialog.open(EmployeesListComponent, dialogConf);

    ref.afterClosed.subscribe((result: Employee[]) => {
      if (result) {
        result.forEach(element => {
          if (this.project.projectWatchers.every(x => x.employeeId != element.id)) {
            let watcher = new ProjectWatcher();
            watcher.id = 0;
            watcher.employee = element;
            watcher.employeeId = element.id;
            watcher.projectId = this.project.id
            watcher.projectWatcherName = `${element.name} ${element.surname}`;
            this.project.projectWatchers.push(watcher);
          }
        });
        this.projectWatchersGrid.refreshData();
      }
    });
  }

  private removeProjectWatcher(row: ProjectWatcher) {
    this.project.projectWatchers.splice(this.project.projectWatchers.indexOf(row), 1);
    if (this.project.id !== 0) {
      this.projectRest.removeProjectWatcher(row.id).subscribe((response: boolean) => {
        if (response)
          this.projectWatchersGrid.refreshAndLoadData();
      });
    }
    this.projectWatchersGrid.refreshData();
  }

  private checkSaveCondition() {
    return true;
  }

  public isInvalid() {
    if (this.checkSaveCondition()) {
      let isNumeratorInvalid = this.numeratorComponent.isInvalid();
      return this.projectForm.invalid || isNumeratorInvalid;
    }
    return false;
  }

  private onBudgetChange(event) {
    this.project.budget = event;
  }

  private onHourlyRateChange(event) {
    this.project.hourlyRate = event;
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }
}
